export const DEBUG_USER_IDS = [2, 16, 53];

export const getAuthUser = () => {
  try {
    return JSON.parse(localStorage.getItem('authUser'));
  } catch (error) {
    return null;
  }
};

export const isDebugUser = (user = getAuthUser()) => DEBUG_USER_IDS.includes(Number(user?.id));
